/* eslint-disable */
import { sharingUsers, sharedTest, annotations, tests, users, stats, userLabels, comments } from './backend-data'
import {dayDifference} from '@/_helpers'
import { uuid } from 'vue-uuid'
import { ecgdata, ecgdata2, bpdata } from '@/_helpers/backend-data/test-data'

let authPhonesList = JSON.parse(localStorage.getItem('authPhones')) || []
let usersList = JSON.parse(localStorage.getItem('users')) || users
let userLabelsList = JSON.parse(localStorage.getItem('userLabels')) || userLabels
let testsList = JSON.parse(localStorage.getItem('tests')) || tests
let annotationsList = JSON.parse(localStorage.getItem('annotations')) || annotations
let commentsList = JSON.parse(localStorage.getItem('comments')) || comments

function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function configureFakeBackend () {
  let realFetch = window.fetch
  window.fetch = function (url, opts) {
    return new Promise((resolve, reject) => {
      console.log('New request to url: ', url)
      // wrap in timeout to simulate server api call
      setTimeout(() => {
        
        // signup
        if (url.endsWith('/signup') && opts.method === 'POST') {
          // get parameters from post request
          let params = JSON.parse(opts.body)

          // find if any user matches login credentials
          let filteredUsers = usersList.filter(user => {
            return user.phone === params.user.phone
          })

          if (filteredUsers.length) {
            reject(JSON.stringify('403 - phone number exists'))
          } else {
            authPhonesList = [params.user]
            localStorage.setItem('authPhones', JSON.stringify(authPhonesList))
            resolve({ ok: true, text: () => Promise.resolve("") })
          }

          return
        }

        // signin
        if (url.endsWith('/signin') && opts.method === 'POST') {
          // get parameters from post request
          let params = JSON.parse(opts.body)
          // find if any user matches login credentials
          let filteredUsers = usersList.filter(user => {
            return user.phone === params.phone
          })

          if (filteredUsers.length) {
            authPhonesList = [{...params, type: 'signin'}]
            localStorage.setItem('authPhones', JSON.stringify(authPhonesList))
            console.log(authPhonesList)
            resolve({ ok: true, text: () => Promise.resolve("") })
          } else {
            reject(JSON.stringify('404 - user not found'))
          }

          return
        }

        // authenticate
        if (url.endsWith('/authenticate') && opts.method === 'POST') {
          // get parameters from post request
          let params = JSON.parse(opts.body)

          if (params.verification_code !== '123456') {
            reject(JSON.stringify('401 - auth forbidden'))
            return
          }

          let isSignin = false
          let phone = ''
          let filteredAuthPhones = authPhonesList.filter(auth => {
            if (auth.hasOwnProperty('type') && auth.type === 'signin') {
              isSignin = true
            }
            phone = params.phone
            return auth.phone === params.phone
          })

          if (filteredAuthPhones.length) {
            let result = false
            if (isSignin) {
              // find if any user matches login credentials
              let filteredUsers = usersList.filter(user => {
                return user.phone === phone
              })

              if (filteredUsers.length) {
                result = true
              }
            } else {
              // find if any user matches login credentials
              let filteredUsers = usersList.filter(user => {
                return user.phone === phone
              })

              if (filteredUsers.length === 0) {
                var user = authPhonesList[0]
                user.uuid = uuid.v4()
                usersList.push(user)
                localStorage.setItem('users', JSON.stringify(usersList))

                result = true
              }
            }

            let responseJson = {
              refresh_token: 'fake-jwt-token',
              access_token: 'fake-jwt-token'
            }
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(responseJson)) })
          } else {
            reject(JSON.stringify('401 - auth forbidden'))
          }

          return
        }

        // write auth enabled apis after this block
        var currentUserUuid = 'ec4de62a-cecc-40e8-b066-8a7297633d5c'
        /* if (opts.headers && opts.headers.Authorization === 'Bearer fake-jwt-token') {
        } else {
          // return 401 not authorised if token is null or invalid
          reject('Unauthorised')
        } */

        if (url.endsWith('/wallet') && opts.method === 'GET') {
          let res = {
            balance: 100000
          }
          resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(res))})
          return
        }

        if (url.match(/\/balance_history(.*?)$/) && opts.method === 'GET') {
          let res = [
            {
              "run_id": "*topup",
              "setup_time": 1642621666.432273,
              "cost": 100000
            },
            {
              "run_id": "*debit",
              "setup_time": 1642158031.029748,
              "cost": 10
            },
            {
              "run_id": "*topup",
              "setup_time": 1642158129.898153,
              "cost": 10
            },
            {
              "run_id": "*debit",
              "setup_time": 1642157964.431553,
              "cost": 10
            }
          ]
          resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(res))})
          return
        }

        if (url.match(/\/user_stats(.*?)$/) && opts.method === 'GET') {
          let filteredUser = stats.filter(stat => {
            return stat.user_uuid === currentUserUuid
          })
          if (filteredUser.length) {
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(filteredUser[0]))})
          } else {
            reject(JSON.stringify('404 - not found'))
          }
          return
        }

        if (url.match(/\/avatar(.*?)$/) && opts.method === 'GET') {
          reject({status: 404, statusText: '404 - Not found'})
          return
        }

        if (url.match(/\/profile(.*?)$/) && opts.method === 'GET') {
          var userUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')

          let filteredUser = usersList.filter(user => {
            return user.uuid === userUuid
          })
          if (filteredUser.length) {
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(filteredUser[0]))})
          } else {
            reject(JSON.stringify('404 - user not found'))
          }

          return
        }

        if (url.match(/\/user_label(.*?)$/)) {
          var userUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')

          if (opts.method === 'PUT') {
            let params = JSON.parse(opts.body)
            var replaced = false
            var updatedLabel = null
            userLabelsList = userLabelsList.map(lbl => {
              if (lbl.patient_uuid === userUuid && lbl.user_uuid === currentUserUuid) {
                replaced = true
                lbl.label = params.label
                lbl.created_at = Math.floor(Date.now() / 1000)
                updatedLabel = {...lbl}
              }
              return lbl
            })

            if (!replaced) {
              let label = {}
              label.label = params.label
              label.uuid = uuid.v4()
              label.patient_uuid = userUuid
              label.user_uuid = currentUserUuid
              label.created_at = Math.floor(Date.now() / 1000)
              userLabelsList.push(label)
              updatedLabel = {...label}
            }

            localStorage.setItem('userLabels', JSON.stringify(userLabelsList))
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(updatedLabel))})
          }
          return
        }

        if (url.match(/\/sharing_user(.*?)$/) && opts.method === 'GET') {
          var queryName = getParameterByName('name', url)
          var queryLabel = getParameterByName('label', url)

          sharingUsers.sort((a,b) => (a.created_at > b.created_at) ? -1 : ((b.created_at > a.created_at) ? 1 : 0))

          var currentUserLabels = userLabelsList.filter(label => {
            return label.user_uuid === currentUserUuid
          })
          var currentSharingUsers = sharingUsers.map(user => {
            var label = currentUserLabels.filter(lbl => {
              return lbl.patient_uuid === user.uuid
            })

            if (queryLabel.length > 0) {
              user.label = queryLabel
            } else if (label.length > 0) {
              user.label = label[0].label
            }

            return user
          })

          if (queryName.length === 0) {
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(currentSharingUsers)) })
          } else if (queryName.length > 0) {
            let filteredUsers = currentSharingUsers.filter(user => {
              return user.first_name.startsWith(queryName) || user.last_name.startsWith(queryName) || (queryName.length == 12 && user.phone === queryName)
            })
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(filteredUsers)) })
          } else if (currentSharingUsers.length === 0) {
            reject(JSON.stringify('404 - not found'))
          }

          return
        }

        if (url.match(/\/test_profile(.*?)$/) && opts.method === 'GET') {
          var userUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')

          let filteredUser = usersList.filter(user => {
            return user.uuid === userUuid
          })
          if (filteredUser.length === 0) {
            reject(JSON.stringify('404 - user not found'))
            /* resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(filteredUser[0]))}) */
            return
          }

          let filteredUserLabel = userLabelsList.filter(label => {
            return label.user_uuid === currentUserUuid && label.patient_uuid === userUuid
          })

          // sort annotations by date
          annotationsList.sort((a,b) => (a.created_at > b.created_at) ? -1 : ((b.created_at > a.created_at) ? 1 : 0))
          testsList.sort((a,b) => (a.tested_at > b.tested_at) ? -1 : ((b.tested_at > a.tested_at) ? 1 : 0))
          filteredUserLabel.sort((a,b) => (a.created_at > b.created_at) ? -1 : ((b.created_at > a.created_at) ? 1 : 0))
          var st = {...sharedTest}
          st.user = filteredUser[0]

          if (filteredUserLabel.length > 0) {
            st.user_label = filteredUserLabel[0]
          } else {
            st.user_label = null
          }

          var bpTest = testsList.filter(test => {
            return test.type === 'bp'
          })
          var ecgTest = testsList.filter(test => {
            return test.type === 'ecg'
          })
          var userTests = []
          if (bpTest.length > 0) {
            var startOfDay = (new Date(bpTest[0].tested_at * 1000).setHours(0,0,0,0)) / 1000
            bpTest.forEach(test => {
              if (test.tested_at >= startOfDay) {
                userTests.push(test)
              }
            })
          }
          if (ecgTest.length > 0) {
            userTests.push(ecgTest[0])
          }
          st.last_tests = userTests
          st.last_annotations = [
            annotationsList[0]
          ]
          resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(st))})
          return
        }

        if (url.match(/\/test_comments(.*?)$/)) {
          var testUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')
          
          if(opts.method === 'GET') {
            // check test shared with this user... (this is a test incomplete code for this)
            var tests = testsList.filter(t => {
              if (t.user_uuid === currentUserUuid) {
                return true
              }
              return false
            })
            if (tests.length === 0) {
              reject({status: 404, statusText: '404 - Not found'})
              return
            }

            var comments = commentsList.filter(c => {
              if (c.test_uuid === testUuid) {
                return true
              }
              return false
            })
            if (comments.length === 0) {
              reject({status: 404, statusText: '404 - Not found'})
              return
            }
            // order should be ascending
            comments.sort((a,b) => (a.created_at > b.created_at) ? 1 : ((b.created_at > a.created_at) ? -1 : 0))
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(comments))})
          }

          if(opts.method === 'POST') {
            let params = JSON.parse(opts.body)
            var comment = {
              uuid: uuid.v4(),
              text: params.text,
              created_at: new Date().getTime() / 1000,
              user_uuid: currentUserUuid,
              test_uuid: params.test_uuid,
              type: params.type
            }
            commentsList.push(comment)
            localStorage.setItem('comments', JSON.stringify(commentsList))
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(comment))})
          }

          return
        }
        
        if (url.match(/\/test_summary(.*?)$/) && opts.method === 'GET') {
          var queryContext = getParameterByName('context', url)
          var queryPatientUuid = getParameterByName('patient_uuid', url)
          var queryFromDate = getParameterByName('from_date', url)
          if (queryFromDate.length > 0) {
            queryFromDate = parseInt(queryFromDate)
          } else {
            queryFromDate = 0
          }
          // check patient exists...
          
          // filter tests by patient_uuid and from_date
          if (queryContext === 'doctor') {
            var filteredTests = testsList.filter(test => {
              return test.user_uuid === queryPatientUuid && test.tested_at >= queryFromDate
            })
            filteredTests.sort((a,b) => (a.tested_at > b.tested_at) ? 1 : ((b.tested_at > a.tested_at) ? -1 : 0))

            var testSummaries = []
            filteredTests.forEach(test => {
              let random = Math.floor(Math.random() * 120)
              testSummaries.push({
                tested_at: test.tested_at,
                sys: random,
                dia: random,
                hr: random
              })
            })
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(testSummaries))})
            return
          }
          reject({status: 404, statusText: '404 - Not found'})
          return
        }

        if (url.match(/\/test_data(.*?)$/) && opts.method === 'GET') {
          var testUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')
          if (testUuid !== 'test_data' && testUuid.length > 0) {
            var reqTest = testsList.filter(test => {
              return test.uuid === testUuid
            })

            if (reqTest.length > 0 && reqTest[0].type === 'ecg') {
              resolve({ ok: true, text: () => Promise.resolve(ecgdata2)})
              return
            } else if (reqTest.length > 0 && reqTest[0].type === 'bp') {
              resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(bpdata))})
              return
            }
          }
          reject({status: 404, statusText: '404 - Not found'})
          return
        }

        if (url.match(/\/test_tags(.*?)$/) && opts.method === 'PUT') {
          var testUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')
          let params = JSON.parse(opts.body)
          testsList = testsList.map(test => {
            if (test.uuid === testUuid) {
              test.tags = params.tags
            }
            return test
          })
          localStorage.setItem('tests', JSON.stringify(testsList))
          resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(params))})
          return
        }

        if (url.match(/\/test(.*?)$/) && opts.method === 'GET') {
          var userUuid = getParameterByName('user_uid', url)
          var context = getParameterByName('context', url)
          var type = getParameterByName('type', url)
          var queryFromDate = getParameterByName('from_date', url)
          if (queryFromDate.length > 0) {
            queryFromDate = parseInt(queryFromDate)
          } else {
            queryFromDate = 0
          }

          var queryToDate = getParameterByName('to_date', url)
          if (queryToDate.length > 0) {
            queryToDate = parseInt(queryToDate)
          } else {
            queryToDate = 0
          }

          let filteredTests = testsList.filter(test => {
            var res = test.user_uuid === userUuid;
            if (type.length > 0) {
              res = res && test.type === type
            }
            if (queryFromDate > 0) {
              res = res && test.tested_at >= queryFromDate
            }
            if (queryToDate > 0) {
              res = res && test.tested_at <= queryToDate
            }
            return res
          })

          if (context === 'daily') {
            if (filteredTests.length > 0) {
              resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(filteredTests))})
            } else {
              reject({status: 404, statusText: '404 - Not found'})
            }
          }
          if (context === 'minimal') {
            var flags = 0
            filteredTests.forEach(element => {
              var days = dayDifference(queryFromDate, element.tested_at)
              flags |= (1 << days)
            })
            var response = {
              value: flags
            }
  
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(response))})
          }
          
          return
        }

        if (url.match(/\/annotation(.*?)$/)) {
          var annotationUuid = url.replace(/^.*[\\\/]/, '').replace(/\?.*/, '')
          var isCollectionApi = (annotationUuid === 'annotation') || (annotationUuid.length === 0)

          // new annotation api
          if (isCollectionApi && opts.method === 'POST') {
            let params = JSON.parse(opts.body)
            let annotation = {}
            annotation.description = params.annotation
            annotation.uuid = uuid.v4()
            annotation.patient_uuid = params.patient_uuid
            annotation.user_uuid = currentUserUuid
            annotation.created_at = Math.floor(Date.now() / 1000)
            annotationsList.push(annotation)
            localStorage.setItem('annotations', JSON.stringify(annotationsList))
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(annotation))})
          }

          // get list of annotations
          if (!isCollectionApi && opts.method === 'GET') {
            var queryFromDate = getParameterByName('from_date', url)
            if (queryFromDate.length > 0) {
              queryFromDate = parseInt(queryFromDate)
            } else {
              queryFromDate = 0
            }

            var queryToDate = getParameterByName('to_date', url)
            if (queryToDate.length > 0) {
              queryToDate = parseInt(queryToDate)
            } else {
              queryToDate = 0
            }

            // its actually user id for this api...
            var userUuid = annotationUuid
            let filteredAnnotations = annotationsList.filter(annotation => {
              var res = annotation.user_uuid === currentUserUuid
              res = res && annotation.patient_uuid === userUuid
              if (queryFromDate > 0) {
                res = res && annotation.created_at >= queryFromDate
              }
              if (queryToDate > 0) {
                res = res && annotation.created_at <= queryToDate
              }
              return res
            })

            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(filteredAnnotations))})
          }

          // update annotation
          if (!isCollectionApi && opts.method === 'PUT') {
            annotationsList = annotationsList.map(annotation => {
              if (annotation.uuid === annotationUuid) {
                let params = JSON.parse(opts.body)
                annotation.description = params.annotation
              }
              return annotation
            })
            var a = annotationsList.filter(annotation => {
              if (annotation.uuid === annotationUuid) {
                return true
              }
              return false
            })
            localStorage.setItem('annotations', JSON.stringify(annotationsList))
            resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(a[0]))})
          }

          // remove annotation
          if (!isCollectionApi && opts.method === 'DELETE') {
            annotationsList = annotationsList.filter(annotation => {
              if (annotation.uuid === annotationUuid) {
                return false
              }
              return true
            })
            localStorage.setItem('annotations', JSON.stringify(annotationsList))
            resolve({ ok: true, text: () => Promise.resolve()})
          }
          return
        }

        // pass through any requests not handled above
        realFetch(url, opts).then(response => resolve(response))
      }, 500)
    })
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/fake-backend.js